import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { SERVICE_BY_KIND } from "@/lib/categories";
import { CalendarCheck, ArrowRight } from "lucide-react";

// Relevance map: which bookable services suit a given content type / section.
const TYPE_SERVICES = {
  puja_vidhi: ["pooja", "homam"],
  festival: ["pooja", "homam"],
  stotra: ["pooja"],
  mantra: ["pooja", "homam"],
  katha: ["pooja"],
  vedic: ["yagya", "homam"],
  sukta: ["yagya", "homam"],
};
const SECTION_SERVICES = {
  samskara: ["pooja", "homam"],
  vrata: ["pooja"],
  pilgrimage: ["pooja"],
  traditions: ["pooja"],
  concepts: ["pooja"],
  scriptures: ["yagya"],
  rishis: ["yagya"],
};

export default function RelatedServices({ type, section, deity }) {
  const { pick } = useLang();
  const kinds = (type ? TYPE_SERVICES[type] : SECTION_SERVICES[section]) || ["pooja"];
  const services = kinds.map((k) => SERVICE_BY_KIND[k]).filter(Boolean).slice(0, 3);
  if (services.length === 0) return null;

  const deityLine = deity
    ? pick(`${deity} से संबंधित पूजा, होम अथवा यज्ञ पारंपरिक विधि से संपन्न कराएँ।`,
           `Have a ${deity}-related pooja, homam or yagya performed for you in the traditional way.`)
    : pick("इस विषय से संबंधित पूजा, होम अथवा यज्ञ पारंपरिक विधि से संपन्न कराएँ।",
           "Request a related pooja, homam or yagya, performed with care and respect for tradition.");

  return (
    <section className="mt-16" data-testid="related-services">
      <div className="relative overflow-hidden border border-line bg-[var(--surface-alt)]/40 p-7 md:p-9">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div className="max-w-xl">
            <p className="overline-label mb-2 inline-flex items-center gap-2 text-gold">
              <CalendarCheck className="h-3.5 w-3.5" /> {pick("संबंधित सेवाएँ", "Related Services")}
            </p>
            <h3 className="font-serif-latin text-2xl text-ink">{pick("इसे अनुष्ठान में परिणत करें", "Bring this into practice")}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-2">{deityLine}</p>
          </div>
          <div className="flex flex-wrap gap-2.5">
            {services.map((s) => (
              <Link
                key={s.kind}
                to={`/services/${s.kind}`}
                data-testid={`related-service-${s.kind}`}
                className="group inline-flex items-center gap-2 border border-line bg-surface px-4 py-2.5 text-sm text-ink-2 transition-colors hover:border-saffron hover:text-saffron"
              >
                {pick(s.deva, s.en)}
                <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
